export enum MolGuideLinkTypeEnum {
  PRIMARY = "primary",
  SECONDARY = "secondary",
}
